<template>
  <custom-dialog class="company-user-dialog" width="80%" :title="model.title" :visible="visible" v-on="$listeners" @close="onCancel">
    <div class="step-box">
      <t-step v-model="step" :list="stepList" @change="changeStep"></t-step>
    </div>
    <!-- 基本信息 -->
    <user-item-info v-if="step == 1" :type="model.type" :userId="userId" @cancel="onCancel" @step="onStep" @back="onBack" @refresh="onRefresh"></user-item-info>
    <!-- 部门设置 -->
    <user-item-department v-if="step == 2" :type="model.type" :userId="userId" @cancel="onCancel" @step="onStep" @back="onBack"></user-item-department>
    <!-- 设备分配 -->
    <user-item-device v-if="step == 3" :type="model.type" :userId="userId" @cancel="onCancel" @step="onStep" @back="onBack"></user-item-device>
    <!-- 岗位通知 -->
    <user-item-role v-if="step == 4" :type="model.type" :userId="userId" @cancel="onCancel" @step="onStep" @back="onBack"></user-item-role>
  </custom-dialog>
</template>

<script>
import tStep from '@/components/step.vue';
import dialogMixins from '@/mixins/dialog_mixins.js';
import userItemInfo from './company_user_item_info.vue';
import userItemDepartment from './company_user_item_department.vue';
import userItemDevice from './company_user_item_device.vue';
import userItemRole from './company_user_item_role.vue';

// c_user1_yuan_gong_xin_xi: 员工信息// c_user1_lrygjbxx: 录入员工基本信息// c_user1_jia_ru_bu_men: 加入部门// c_user1_xzygjrdbm: 选择员工加入的部门// c_user1_fen_pei_she_bei: 分配设备// c_user1_fpsbgyggl: 分配设备给员工管理// c_user1_syqx: 授予权限// c_user1_sygwhszxx: 授予岗位和设置消息

export default {
  mixins: [dialogMixins],
  components: { tStep, userItemInfo, userItemDepartment, userItemDevice, userItemRole },
  data() {
    return {
      userId: null,
      step: 1,
      refresh: false
    };
  },
  computed: {
    stepList() {
      return [
        {
          label: '1',
          value: 1,
          title: this.$t('c_user1_yuan_gong_xin_xi'),
          subTitle: this.$t('c_user1_lrygjbxx')
        },
        {
          label: 2,
          value: 2,
          title: this.$t('c_user1_jia_ru_bu_men'),
          subTitle: this.$t('c_user1_xzygjrdbm'),
          subNum: ''
        },
        {
          label: '3',
          value: 3,
          title: this.$t('c_user1_fen_pei_she_bei'),
          subTitle: this.$t('c_user1_fpsbgyggl')
        },
        {
          label: '4',
          value: 4,
          title: this.$t('c_user1_syqx'),
          subTitle: this.$t('c_user1_sygwhszxx')
        }
      ];
    }
  },
  created() {
    this.step = this.model.step || 1;
  },
  mounted() {
    this.mergeLanguage(null, 'portal_company_user_dialog');
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.userId = this.model.userId;
      }
    },
    // 刷新
    onRefresh: function () {
      this.refresh = true;
    },
    // 取消
    onCancel: function () {
      this.visible = false;
      this.$emit('close', this.refresh);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    // 下一步
    onStep: function (value) {
      if (value.name === 'info') {
        this.userId = value.userId;
        this.refresh = true;
      }
      this.step++;
    },
    // 变更步骤
    changeStep: function (item) {
      if (this.model.type === 'edit') {
        this.step = item.value;
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-dialog {
  .step-box {
    padding: 16px 24px 24px;
    background: #f8f9fa;
  }
}
</style>
